import { render, staticRenderFns } from "./Table-insurances.vue?vue&type=template&id=da45f4c4&scoped=true&"
import script from "./Table-insurances.vue?vue&type=script&lang=js&"
export * from "./Table-insurances.vue?vue&type=script&lang=js&"
import style0 from "./Table-insurances.vue?vue&type=style&index=0&id=da45f4c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da45f4c4",
  null
  
)

export default component.exports